import React from 'react';
import { Card } from '../Card';

interface NotFoundCardProps {
  title?: string;
  message?: string;
}

export const NotFoundCard: React.FC<NotFoundCardProps> = ({
  title,
  message = 'Resource not found or could not be loaded.',
}) => {
  return (
    <Card padding="lg">
      <div className="text-center text-gray-500">
        {title && <p className="text-lg font-medium mb-2">{title}</p>}
        <p className="text-sm">{message}</p>
      </div>
    </Card>
  );
};
